import { V10_VIEW_META } from "../routing/v10-views.js";
import type { V10View } from "../routing/v10-views.js";

export function V10Topbar({ view }: { readonly view: V10View }) {
  const meta = V10_VIEW_META[view];
  return (
    <header className="v10-topbar">
      <div className="v10-topbar-left">
        <span className="v10-crumb">{meta.title}</span>
        <span className="v10-muted v10-topbar-sub">{meta.subtitle}</span>
      </div>
    </header>
  );
}
